import React from 'react';
import Icon from '../../../components/AppIcon';

const FormProgressIndicator = ({ currentStep, totalSteps, completedSections }) => {
  const steps = [
    { id: 1, title: 'Problem Overview', key: 'overview' },
    { id: 2, title: 'Requirements', key: 'requirements' },
    { id: 3, title: 'Stakeholders', key: 'stakeholders' },
    { id: 4, title: 'Timeline', key: 'timeline' },
    { id: 5, title: 'Review', key: 'review' }
  ];

  const getStepStatus = (step) => {
    if (step?.id < currentStep) return 'completed';
    if (step?.id === currentStep) return 'current';
    return 'pending';
  };

  const isStepCompleted = (stepKey) => {
    return completedSections?.includes(stepKey);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Submission Progress</h3>
        <span className="text-sm text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
      </div>
      <div className="flex items-center space-x-4">
        {steps?.map((step, index) => {
          const status = getStepStatus(step);
          const isCompleted = isStepCompleted(step?.key);
          
          return (
            <React.Fragment key={step?.id}>
              <div className="flex flex-col items-center">
                <div className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-micro
                  ${status === 'completed' || isCompleted
                    ? 'bg-success border-success text-success-foreground'
                    : status === 'current' ?'bg-primary border-primary text-primary-foreground' :'bg-background border-border text-muted-foreground'
                  }
                `}>
                  {status === 'completed' || isCompleted ? (
                    <Icon name="Check" size={16} />
                  ) : (
                    <span className="text-sm font-medium">{step?.id}</span>
                  )}
                </div>
                <span className={`
                  text-xs mt-2 text-center max-w-16
                  ${status === 'current' ? 'text-foreground font-medium' : 'text-muted-foreground'}
                `}>
                  {step?.title}
                </span>
              </div>
              {index < steps?.length - 1 && (
                <div className={`
                  flex-1 h-0.5 transition-micro
                  ${status === 'completed' || isCompleted ? 'bg-success' : 'bg-border'}
                `} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="mt-4 bg-muted rounded-full h-2">
        <div 
          className="bg-primary h-2 rounded-full transition-layout"
          style={{ width: `${(completedSections?.length / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default FormProgressIndicator;